import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export function createStore () {
    return new Vuex.Store({
        state : {
            device : templateDevice
            , skin : templateType
            , sort : templateData.sort
            , detail : templateData.detail
            , updated : false
            , updateCode : ''
            , isAdminEditOn : false
            , productSearchHashTag : ''
            , changedSearchHashTag : false
        },
        mutations : {
            setDetailUse (state, payload) {
                if (typeof payload.code == 'undefined' || typeof payload.use == 'undefined') { return }
                let code    = payload.code;
                let useVal  = payload.use;
                state.detail[code].use = useVal;
                state.updated = true;
                state.updateCode = code;
            }
            , setDetailData (state, payload) {
                if (typeof payload.code == 'undefined' || typeof payload.data == 'undefined') { return }
                let code    = payload.code;
                let data    = payload.data;
                state.detail[code].data = data;
                state.updated = true;
                state.updateCode = code;
            }
            , setDetailLayoutFix (state, payload) {
                if (typeof payload.code == 'undefined' || typeof payload.layout_fix == 'undefined') { return }
                let code    = payload.code;
                let fix     = payload.layout_fix;
                state.detail[code].layout_fix = fix;
                state.updated = true;
                state.updateCode = code;
            }
            , setAdminEditMode (state, payload) {
                state.isAdminEditOn = payload.on
            }
            , setProductSearchHashTag (state, payload) {
                if (typeof payload.tag == 'undefined') return
                state.productSearchHashTag = payload.tag
                state.changedSearchHashTag = true
            }
            , initProductSearchHashTag (state) {
                state.changedSearchHashTag = false
            }
            , initUpdateCode(state) {
                state.updated = false;
                state.updateCode = '';
            }
            , changeDetail (state, data) {
                state.detail = data;
            }
            , changeSort (state, data) {
                state.sort = data;
            }
            , addSortData (state, data) {
                state.sort.push(data);
            }
        },
        actions : {
        }
    })
}
